import { get } from "lodash";

import { I_PropertyDetail } from "@/shared/models/interfaces/entity/property/property.entity";
import { I_Agent } from "@/shared/models/interfaces/entity/agents/agents-base.interface";
import { OwnerDetailResponseDATA } from "@/shared/models/interfaces/response/owners/owner-detail-responses.interface";
import { propertyDetailAdapter } from "../../property/property.adapter.ts/property.adapter";
import { O_IDENTIFICATION } from "@/src-refactor/modules/shared/model/const/indetification.const";

export const detailOwnerAdapter = (data: OwnerDetailResponseDATA) => {
  const detail: OwnerDetail = {
    ownerDetail: PrepareOwnerDetail(data.owner_details),
    ownerProperties: preparePropertyDetail(data.owner_properties),
    agentsRelationship: prepareAgentRelationship(data.list_related_agents)
  };
  return detail;
};

const PrepareOwnerDetail = (
  data: OwnerDetailResponseDATA["owner_details"]
) => {
  const detail: any = {
    id: data?.id ?? null,
    name: data.name ?? null,
    address: data.address ?? null,
    phone: data.phone ?? null,
    phone2: data.phone2 ?? null,
    mobile: data.mobile ?? null,
    fax: data.fax ?? null,
    email: data.email ?? null,
    personal_email: data?.personal_email ?? null,
    birthdate: data.birthdate ?? null,
    country: data.country ?? null,
    country_id: data.country_id ?? null,
    is_conflictive: data.is_conflictive ?? null,
    city: data.city ?? null,
    sector: data.sector ?? null,
    reference: data.reference ?? null,
    identification: {
      id: data.identification ?? null,
      type: data.identification_type
        ? O_IDENTIFICATION[data.identification_type]
        : null
    },
    company: {
      name: data.company_name ?? null,
      identification: data.company_identification ?? null,
      identification2: data.company_identification2 ?? null,
      position: data.company_position ?? null,
      phone: data.company_phone ?? null,
      email: data.company_email ?? null
    }
  };

  return detail;
  // get(data, "id") ? (detail.id = data.id) : null;
  // get(data, "name") ? (detail.name = data.name) : null;
  // get(data, "address") ? (detail.address = data.address) : null;
  // get(data, "phone") ? (detail.phone = data.phone) : null;
  // get(data, "phone2") ? (detail.phone2 = data.phone2) : null;
  // get(data, "mobile") ? (detail.mobile = data.mobile) : null;
  // get(data, "fax") ? (detail.fax = data.fax) : null;
  // get(data, "email") ? (detail.email = data.email) : null;
  // get(data, "personal_email") ? (detail.personal_email = data.personal_email) : null;
  // get(data, "birthdate") ? (detail.birthdate = data.birthdate) : null;
  // get(data, "country") ? (detail.country = data.country) : null;
  // get(data, "country_id") ? (detail.country_id = data.country_id) : null;
  // get(data, "city") ? (detail.city = data.city) : null;
  // get(data, "sector") ? (detail.sector = data.sector) : null;
  // get(data, "reference") ? (detail.reference = data.reference) : null;
  // get(data, "company_name") ? (detail.company.name = data.company_name) : null;
  // get(data, "identification")
  //   ? (detail.identification = {
  //       type: identifyTypeIdentification(data.identification).id,
  //       id: data.identification,
  //   })
  //   : null;
  // get(data, "company_identification")
  //   ? (detail.company.identification = data.company_identification)
  //   : null;
  // get(data, "company_identification2")
  //   ? (detail.company.identification2 = data.company_identification2)
  //   : null;
  // get(data, "company_position")
  //   ? (detail.company.position = data.company_position)
  //   : null;
  // get(data, "company_phone")
  //   ? (detail.company.phone = data.company_phone)
  //   : null;
  // get(data, "company_email")
  //   ? (detail.company.email = data.company_email)
  //   : null;
  // return detail;
};

const preparePropertyDetail = (
  data: OwnerDetailResponseDATA["owner_properties"]
) => {
  const detail: any = [];
  if (data?.length > 0) {
    data.forEach(property => detail.push(propertyDetailAdapter(property)));
  }
  return detail;
};

const prepareAgentRelationship = (
  data: OwnerDetailResponseDATA["list_related_agents"]
) => {
  const detail: any = [];
  if (data?.length > 0) {
    data.forEach(agent => {
      const obj: Partial<I_Agent> = {};
      get(agent, "id") ? (obj.id = agent.id) : null;
      get(agent, "name") ? (obj.name = agent.name) : null;
      get(agent, "email") ? (obj.email = agent.email) : null;
      get(agent, "phone") ? (obj.phone = agent.phone) : null;
      get(agent, "picture_url") ? (obj.picture = agent.picture_url) : null;
      detail.push(obj);
    });
  }
  return detail;
};

export interface OwnerDetail {
  ownerDetail: OwnerDetailData;
  ownerProperties: I_PropertyDetail[];
  agentsRelationship: I_Agent[];
}

export interface OwnerDetailData {
  id: number | null;
  name: string | null;
  identification: { id: number; type: string } | null;
  address: string | null;
  phone: string | null;
  phone2: string | null;
  mobile: string | null;
  fax: string | null;
  email: string | null;
  is_conflictive: number | null;
  birthdate: string | null;
  country: string | null;
  city: string | null;
  sector: string | null;
  reference: string | null;
  company: {
    name: string | null;
    identification: string | null;
    identification2: string | null;
    position: string | null;
    phone: string | null;
    email: string | null;
  } | null;
}
